import { cn } from '@workspace/ui/lib/utils'
import { cva, type VariantProps } from 'class-variance-authority'
import type * as React from 'react'

const textareaVariants = cva(
  'flex min-h-[60px] w-full rounded-md border-none bg-transparent px-3 py-2 text-base transition-all placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-60 outline-none focus-visible:ring-[rgb(249,115,22)]/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive md:text-sm resize-y',
  {
    variants: {
      variant: {
        default:
          'border-border bg-input text-foreground placeholder:text-muted-foreground shadow-xs',
        ghost: 'border-transparent shadow-none',
      },
      textareaSize: {
        default: 'min-h-[80px]',
        sm: 'min-h-[60px] text-xs px-2.5 py-1.5',
        lg: 'min-h-[120px] px-4 py-2.5',
      },
    },
    defaultVariants: {
      variant: 'default',
      textareaSize: 'default',
    },
  }
)

function Textarea({
  className,
  variant,
  textareaSize,
  ...props
}: React.ComponentProps<'textarea'> & VariantProps<typeof textareaVariants>) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(textareaVariants({ variant, textareaSize, className }))}
      {...props}
    />
  )
}

export { Textarea, textareaVariants }
